// ULISH LINE友達登録バナー管理システム
// UTAGEシナリオID対応表:
//   マイページポップアップ: J4EK8ceqV6T0
//   フッター・カート:      Gz4bl2vlFmoz
//
// LINE登録URLの取得方法:
//   UTAGE管理画面 > メッセージ > シナリオ > 該当シナリオ
//   「LINE登録URL」「友達追加URL」を取得して下記に設定
//
(function(){
  'use strict';

  // ===== LINE登録URL（UTAGE管理画面から取得して入力） =====
  var LINE_URL_MYPAGE = 'https://ma.ulishstyle.com/line/open/sgP9Wjapth29?mtid=Q8Rw1w9wddNV';   // マイページ用 (シナリオ J4EK8ceqV6T0)
  var LINE_URL_FOOTER = 'https://ma.ulishstyle.com/line/open/2k8gE5zSsAnc?mtid=q6eCxRceTW5i';   // フッター・カート用 (シナリオ Gz4bl2vlFmoz)
  // ======================================================

  var LINE_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 48 48"><circle cx="24" cy="24" r="24" fill="#06C755"/><path fill="#fff" d="M39.9 22.5c0-8-8-14.5-17.9-14.5S4.1 14.5 4.1 22.5c0 7.2 6.4 13.2 15 14.3.6.1 1.4.4 1.6.9a3.7 3.7 0 0 1 .1 1.6s-.2 1.3-.3 1.5c-.1.5-.4 1.8 1.6 1 10.2-4.2 13.8-11 13.8-16.3zM17 26.3h-3.6a.6.6 0 0 1-.6-.6v-5.6a.6.6 0 0 1 1.2 0v5h3a.6.6 0 1 1 0 1.2zm2.8-.6a.6.6 0 1 1-1.2 0v-5.6a.6.6 0 0 1 1.2 0v5.6zm7.2 0a.6.6 0 0 1-1.1.3l-3-4.2v3.9a.6.6 0 1 1-1.2 0v-5.6a.6.6 0 0 1 1.1-.3l3 4.2v-3.9a.6.6 0 0 1 1.2 0v5.6zm5-4.4h-3v1.3h3a.6.6 0 1 1 0 1.2h-3v1.3h3a.6.6 0 1 1 0 1.2H28a.6.6 0 0 1-.6-.6v-5.6a.6.6 0 0 1 .6-.6h4a.6.6 0 1 1 0 1.2z"/></svg>';

  var CSS = '.ulish-line-popup-ov{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.55);z-index:99998;display:flex;align-items:center;justify-content:center;animation:ulFd .25s}@keyframes ulFd{from{opacity:0}to{opacity:1}}.ulish-line-popup{background:#fff;border-radius:16px;padding:28px 24px 24px;max-width:340px;width:90%;position:relative;text-align:center;box-shadow:0 8px 40px rgba(0,0,0,.22)}.ulish-line-popup__close{position:absolute;top:10px;right:14px;font-size:22px;cursor:pointer;color:#bbb;background:none;border:none;line-height:1;padding:2px 6px}.ulish-line-popup__close:hover{color:#666}.ulish-line-popup h3{font-size:16px;font-weight:700;margin:16px 0 6px;color:#111;letter-spacing:.5px}.ulish-line-popup p{font-size:13px;color:#666;margin:0 0 18px;line-height:1.65}.ulish-line-popup__btn{display:flex;align-items:center;justify-content:center;gap:8px;width:100%;padding:14px;background:#06C755;color:#fff!important;border:none;border-radius:8px;font-size:15px;font-weight:700;cursor:pointer;text-decoration:none!important;letter-spacing:.5px}.ulish-line-popup__btn:hover{background:#05a849}.ulish-line-popup__skip{display:block;margin-top:10px;font-size:12px;color:#aaa;cursor:pointer;text-decoration:underline;background:none;border:none;width:100%}';

  function injectStyle(){
    if(document.getElementById('ulish-line-css')) return;
    var s=document.createElement('style');
    s.id='ulish-line-css';
    s.textContent=CSS;
    document.head.appendChild(s);
  }

  function createPopup(url){
    var ov=document.createElement('div');
    ov.className='ulish-line-popup-ov';
    ov.innerHTML='<div class="ulish-line-popup" role="dialog" aria-modal="true">'+
      '<button class="ulish-line-popup__close" aria-label="閉じる">&times;</button>'+
      LINE_SVG+
      '<h3>ULISH公式LINEで<br>会員様限定情報をお届け</h3>'+
      '<p>先行セール・限定クーポン・新商品情報を<br>LINEでいち早くお届けします。</p>'+
      '<a href="'+url+'" class="ulish-line-popup__btn" target="_blank" rel="noopener">'+
        LINE_SVG+'&ensp;LINE友達追加でクーポンをGET'+
      '</a>'+
      '<button class="ulish-line-popup__skip">今はしない</button>'+
    '</div>';
    var close=function(){
      ov.remove();
      sessionStorage.setItem('ulish_line_shown','1');
    };
    ov.querySelector('.ulish-line-popup__close').addEventListener('click',close);
    ov.querySelector('.ulish-line-popup__skip').addEventListener('click',close);
    ov.addEventListener('click',function(e){if(e.target===ov)close();});
    return ov;
  }

  function initMyPagePopup(){
    if(!LINE_URL_MYPAGE||LINE_URL_MYPAGE.indexOf('LINE_URL')===0) return;
    if(sessionStorage.getItem('ulish_line_shown')) return;
    setTimeout(function(){
      if(!document.querySelector('.ulish-line-popup-ov')){
        injectStyle();
        document.body.appendChild(createPopup(LINE_URL_MYPAGE));
      }
    },2000);
  }

  function init(){
    var path=location.pathname;
    if(path==='/account'||path.startsWith('/account/')){
      if(document.readyState==='loading'){
        document.addEventListener('DOMContentLoaded',initMyPagePopup);
      } else {
        initMyPagePopup();
      }
    }
  }

  init();
  window.UlishLineBanner={
    showPopup:function(url){
      injectStyle();
      document.body.appendChild(createPopup(url||LINE_URL_MYPAGE));
    },
    getFooterUrl:function(){return LINE_URL_FOOTER;}
  };
})();
